import * as React from 'react'
import theme from '../theme'

interface Props {
  colour?: string
}

const CheckCircleIcon = (props: Props): JSX.Element => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 42 42'>
      <title>Check Circle</title>
      <path
        fill={props.colour ? props.colour : theme.colours.success1}
        fillRule='evenodd'
        d='M40.25 19.425V21c0 10.675-8.575 19.25-19.25 19.25S1.75 31.675 1.75 21 10.325 1.75 21 1.75c2.625 0 5.425.525 7.875 1.75.875.35 1.225 1.4.875 2.275-.35.875-1.4 1.225-2.275.875-2.1-.875-4.2-1.4-6.475-1.4-8.75 0-15.75 7-15.75 15.75s7 15.75 15.75 15.75 15.75-7 15.75-15.75v-1.575c0-1.05.7-1.75 1.75-1.75s1.75.7 1.75 1.75zm1.225-15.4c-.7-.7-1.75-.7-2.45 0L21 22.05l-4.025-4.025c-.7-.7-1.75-.7-2.45 0-.7.7-.7 1.75 0 2.45l5.25 5.25c.35.35.875.525 1.225.525.35 0 .875-.175 1.225-.525l19.25-19.25c.7-.7.7-1.75 0-2.45z'
      />
    </svg>
  )
}

export default CheckCircleIcon
